import { Button } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

type OutlineButtonProps = {
  onClick?: (e: any) => void;
  children?: string;
  href?: string;
};
const OutlineButton = ({ onClick, children, href }: OutlineButtonProps) => {
  const classes = useStyles();
  return (
    <Button className={classes.btnOutline} variant="outlined" onClick={onClick} href={href}>
      {children}
    </Button>
  );
};

const useStyles = makeStyles((theme: Theme) => {
  return {
    btnOutline: {
      '&.MuiButton-root': {
        borderRadius: '100px',
        border: `1px solid ${theme.palette.black.main}`,
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(4),
        paddingBottom: theme.spacing(1),
        paddingRight: theme.spacing(4),
        marginLeft: theme.spacing(4),
        lineHeight: '1rem',
        color: theme.palette.black.main,
        '&:hover': {
          border: `1px solid ${theme.palette.black.main}`,
          outline: `1px solid ${theme.palette.black.main}`,
          color: theme.palette.black.main,
        },
      },
    },
  };
});

export default OutlineButton;
